import React from "react";
import { motion, AnimatePresence } from "framer-motion";

interface ModalBottomSheetProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const ModalBottomSheet: React.FC<ModalBottomSheetProps> = ({ open, onClose, children }) => (
  <AnimatePresence>
    {open && (
      <div
        className="fixed inset-0 z-50 flex items-end justify-center bg-black bg-opacity-40"
        onClick={onClose}
      >
        <motion.div
          className="w-full max-w-md bg-gray-800 rounded-t-2xl pb-6 shadow-lg"
          initial={{ y: "100%" }}
          animate={{ y: 0 }}
          exit={{ y: "100%" }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          onClick={e => e.stopPropagation()}
        >
          {children}
        </motion.div>
      </div>
    )}
  </AnimatePresence>
);

export default ModalBottomSheet; 
